import React, { useState } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
// @material-ui/lab components
// @material-ui/icons components
// core components
import Snackbar from "components/Snackbar/Snackbar.js";
import componentStyles from "assets/theme/views/admin/react-bs-table.js";
import btnComponentStyles from "assets/theme/components/button.js";
import LoadingAnimation from "components/Animations/loading";
import Slide from "@material-ui/core/Slide";
import { useAsyncEffect } from "use-async-effect";
import QrReader from "react-qr-reader";
import Tooltip from "@material-ui/core/Tooltip";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown";
import FormGroup from "@material-ui/core/FormGroup";
import FormLabel from "@material-ui/core/FormLabel";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { getAllActiveServicesAndPerItemLaundry,laundryTagQrs,getLaundryOrderDetails,getSubscriptionPackageFromSubId } from "../../network/ApiAxios";
import { redirectToLogout } from "common/SharedFn";
import { ArrowBack } from "@material-ui/icons";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles(componentStyles);
const useStylesButtons = makeStyles(btnComponentStyles);
const createHistory = require("history").createBrowserHistory;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const TagQrCodesPage = (props) => {
  const classes = { ...useStyles(), ...useStylesButtons() };
  const [alert, setAlert] = React.useState(false);
  const [isLoading, setIsLoading] = useState("");
  const [notifMessage, setNotifMessage] = useState("");
  const [success, setSuccess] = React.useState(false);
  const [showError, setShowError] = React.useState(false);
  const [id, setId] = useState();
  const [forceRefresh, setForceRefresh] = useState(false);
  const [qrTagRead, setQrTagRead] = useState(false);
  const [order, setOrder] = useState();
  const [currentSequence, setCurrentSequence] = useState(0);
  const [currentTotal, setCurrentTotal] = useState(0);
  const [qrTags, setQrTags] = useState([]);
  const [services, setServices] = useState([]);
  const [subPackage, setSubPackage] = useState();
  const [selectedAdditionalBagType, setSelectedAdditionalBagType] = useState();
  const [additionalBagModal, setAdditionalBagModal] = useState(false);
  const [scanQrModal, setScanQrModal] = useState(false);
  const [file, setFile] = React.useState(null);
  const [imageUrl, setImageUrl] = useState("");
  const [uploadFiles, setUploadFiles] = useState([]);
  let history = useHistory();
  var currentOrderId = props.match.params.id;
  var sequence = 0;
  var hasPerItem = false;

  let fileInput = React.createRef();

  const handleImageChange = (e, sequence) => {
    e.preventDefault();
    let reader = new FileReader();
    let fileArray = [];
    let newFile = e.target.files[0];
    let uploadFile ={
      sequence:sequence,
      file:e.target.files[0]
    };
    fileArray.push(newFile);
    if(uploadFiles&& uploadFiles?.find(x=>x?.sequence===sequence)) {
      let newData = [...uploadFiles]
      newData[sequence][file]=e.target.files[0]
      setUploadFiles(newData);
    } else {
      let newData = [...uploadFiles,uploadFile]
      setUploadFiles(newData)
    }
  };

  const tableCellHeadTableHeadClassesObj = {
    root: classes.tableCellRoot + " " + classes.tableCellRootHead,
  };

  const handleQrScan = (data) => {
    if (data && !qrTagRead) {
      setQrTagRead(true);
      qrTags[currentSequence].qrTag = data;
      setScanQrModal(false);
      setQrTagRead(false);
      // fetchOrderDetails(data);
    }
  };
  const handleQrError = (err) => {
    console.error(err);
    setScanQrModal(false);
  };

  const showSuccessNotification = (message) => {
    setNotifMessage(message);
    setSuccess(true);
    setTimeout(function () {
      setSuccess(false);
    }, 3000);
  };

  const showErrorNotification = (message) => {
    setNotifMessage(message);
    setShowError(true);
    setTimeout(function () {
      setShowError(false);
    }, 3000);
  };

  const accessOrderPage = (id) => {
    let history = createHistory();
    history.push("/admin/laundryOrders/" + id);
    let pathUrl = window.location.href;
    window.location.href = pathUrl;
  };

  const tagQrsAndUpdateStatusAction = async () => {
    setIsLoading(true);
    try {
      var qrs = [];
      const newArrayOfFiles = uploadFiles.map(x=>x?.file);
      for (var i = 0; i < qrTags.length; i++) {
        qrs.push({ serviceId: qrTags[i].serviceId, tag: qrTags[i].qrTag, isAdditional: qrTags[i].isAdditional,weight:0});
      }
      const response = await laundryTagQrs(order.id, 5, qrs,newArrayOfFiles);
      const { data } = response;
      if (data.result.isSuccess) {
        showSuccessNotification("Status Updated Successfully");
        accessOrderPage(order.id);
      } else {
        showErrorNotification(data.result.description);
        setIsLoading(false);
      }
    } catch (ex) {
      showErrorNotification("Failed to update status");
      setIsLoading(false);
    }
  };

  const fetchOrderDetails = async () => {
    setForceRefresh(false);
    setIsLoading(true);
    try {
      const response = await getLaundryOrderDetails(currentOrderId);
      const responseServices = await getAllActiveServicesAndPerItemLaundry();
      const { data } = response;
      var responsePackage;
      if(data.data.subscriptionId != null){
        responsePackage = await getSubscriptionPackageFromSubId(data.data.subscriptionId);
      }
      if (data.result.isSuccess) {
        setServices(responseServices.data.data.filter(x=>x.isPerItem === 0 && (x.nameEn.toLowerCase().includes("hanged") || x.nameEn.toLowerCase().includes("folded"))));
        if(data.data.subscriptionId != null){
        setSubPackage(responsePackage.data.data);
        }
        setOrder(data.data);
        if(data.data.subscriptionId == null){
          var perItemService = null;
          responseServices.data.data.map(function (service, i) {
            if(service.id == localStorage.getItem("perItemServiceId")){
              perItemService = service;
              return;
            }
          });

          // data.data.orderServicesById.map(function (service, i) {
          //   for (var j = 0; j < service.quantity; j++) {
          //     if(service.serviceByServiceId.isPerItem === 0){
          //       qrTags.push({
          //         seq: sequence,
          //         img: service.serviceByServiceId.bagImageUrl,
          //         name: service.serviceByServiceId.nameEn,
          //         qrTag: "",
          //         serviceId: service.serviceByServiceId.id,
          //         isAdditional: false
          //       });
          //       sequence = sequence + 1;
          //     }
          //     else{
          //       hasPerItem = true;
          //     }
          //   }
          // });
          // if(hasPerItem){
          //   qrTags.push({
          //     seq: sequence,
          //     img: perItemService.bagImageUrl,
          //     name: perItemService.nameEn,
          //     qrTag: "",
          //     serviceId: perItemService.id,
          //     isAdditional: false
          //   });
          //   sequence = sequence + 1;
          // }
        }
        setCurrentTotal(sequence);
      } else {
        showErrorNotification(data.result.description);
        if (data.result.code == -2) {
          redirectToLogout();
        }
      }
    } catch (ex) {
      showErrorNotification("Failed to fetch order details " + ex);
    }
    setIsLoading(false);
  };

  const isShowSaveButton = () => {
    return (order == null || subPackage == null || order.subscriptionId == null || (order.subscriptionId != null && currentTotal > 0)) && isImageUploaded();
  }

  const addAdditionalBag = () => {
    var selectedService;
    for(var i=0;i<services.length;i++){
        if(services[i].id == selectedAdditionalBagType){
          selectedService = services[i];
          break;
        }
    }
    qrTags.push({
      seq: currentTotal,
      img: selectedService.bagImageUrl,
      name: selectedService.nameEn,
      qrTag: "",
      serviceId: selectedService.id,
      isAdditional: order.subscriptionId == null ? true : (order.subscriptionId != null && subPackage.upToBags <= currentTotal)
    });
    setCurrentTotal(currentTotal + 1);
    setAdditionalBagModal(false);
  }

  const isAllTagged = () => {
    for (var j = 0; j < qrTags.length; j++) {
      if (qrTags[j].qrTag == null || qrTags[j].qrTag == "") {
        return false;
      }
    }
    return true;
  };

  const isImageUploaded = () => {
    if((order != null && (order.isShoeOrder == 1)) && (uploadFiles.length == 0)){
      return false;
    }
    return true;
  };

  const getServiceTableRow = (sequence, img, name, qrTag, button) => {
    return (
      <TableRow key={sequence}>
        <TableCell>
          <img src={img} width="40px" />
        </TableCell>
        <TableCell style={{ fontSize: "24px", fontWeight: "bold" }}>
          {name}
        </TableCell>
        <TableCell style={{ fontSize: "24px", fontWeight: "bold" }}>
          {qrTag == null || qrTag == "" ? (
            <Tooltip title="Tag QR" style={{ margin: "5px" }}>
              <Button
                variant="contained"
                size="medium"
                classes={{
                  root: classes.buttonContainedSuccess,
                }}
                onClick={() => {
                  setCurrentSequence(sequence);
                  setScanQrModal(true);
                }}
              >
                <span>Tag Qr Code</span>
              </Button>
            </Tooltip>
          ) : (
            <div>
              QR Tagged ✅{" "}
              <Tooltip title="Re-Tag QR" style={{ margin: "5px" }}>
                <Button
                  variant="contained"
                  size="small"
                  classes={{
                    root: classes.buttonContainedWarning,
                  }}
                  onClick={() => {
                    setCurrentSequence(sequence);
                    setScanQrModal(true);
                  }}
                >
                  <span>Re-Tag Qr</span>
                </Button>
              </Tooltip>
            </div>
          )}
        </TableCell>
        <TableCell>
          {order != null && order.isShoeOrder == 1 ? (<FormGroup>
                    <FormControl variant="outlined" fullWidth>
                        <div className="fileinput">
                        <div className={"thumbnail"}>
                            <img src={imageUrl} width="100px" />
                          </div>
                          <input
                            type="file"
                            id="imageFile"
                            onChange={(e) => handleImageChange(e, sequence)}
                            ref={fileInput}
                          />
                        </div>
                    </FormControl>
                  </FormGroup>) : '' }
        </TableCell>
      </TableRow>
    );
  };

  useAsyncEffect(async () => {
    if (order == null) {
      fetchOrderDetails();
    }
  }, [order]);

  return (
    <>
      {alert}
      {/* Page content */}
      <Container
        maxWidth={false}
        component={Box}
        marginTop="-4.5rem"
        classes={{ root: classes.containerRoot }}
      >
        <Grid container>
          <Grid item xs={12}>
            <Card elevation={0}>
              <CardHeader
                subheader={
                  <>
                    <Box
                      component={Typography}
                      variant="h2"
                      marginBottom="0!important"
                    >
                      <Tooltip title="Back">
                        <Button
                          size="small"
                          classes={{
                            root: classes.buttonContainedPrimary,
                          }}
                          variant="contained"
                          style={{ marginRight: "20px" }}
                          onClick={() => {
                            history.goBack();
                          }}
                        >
                          <Box component={ArrowBack} />
                        </Button>
                      </Tooltip>
                      <Box component="span">
                        Tag QR Codes for Order #{order != null ? order.publicId: ''} and Mark as
                        Washed
                      </Box>
                    </Box>
                  </>
                }
                classes={{ root: classes.cardHeaderRoot }}
              ></CardHeader>
              {isLoading ? (
                <Box
                  component={Grid}
                  container
                  justifyContent="center"
                  className="justify-content-center"
                >
                  <div className="text-center" style={{ width: "20%" }}>
                    <LoadingAnimation />{" "}
                  </div>
                </Box>
              ) : (
                <Grid container>
                  <Grid item xs={12}>
                    <Grid container justify="space-between">
                      <Grid item xs={12} sm={12} md={12}>
                        <Card>
                          <CardHeader
                            subheader={
                              <>
                                <Box component="span">Tag Bags</Box>
                              </>
                            }
                            classes={{ root: classes.cardHeaderRoot }}
                          ></CardHeader>
                          <TableContainer
                            style={{
                              paddingLeft: "26px",
                              paddingRight: "26px",
                            }}
                          >
                            <Box
                              component={Table}
                              alignItems="center"
                              marginBottom="0!important"
                            >
                              <TableHead>
                                <TableRow>
                                  <TableCell
                                    classes={tableCellHeadTableHeadClassesObj}
                                  >
                                    Bag
                                  </TableCell>
                                  <TableCell
                                    classes={tableCellHeadTableHeadClassesObj}
                                  >
                                    Service
                                  </TableCell>

                                  <TableCell
                                    classes={tableCellHeadTableHeadClassesObj}
                                  >
                                    QR Tag
                                  </TableCell>
                                  <TableCell
                                    classes={tableCellHeadTableHeadClassesObj}
                                  >
                                    {order != null && order.isShoeOrder == 1 ?"Upload Item Photo*":""}
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {qrTags != null && qrTags.length > 0
                                  ? qrTags.map(function (service, i) {
                                      return getServiceTableRow(
                                        service.seq,
                                        service.img,
                                        service.name,
                                        service.qrTag
                                      );
                                    })
                                  : ''}
                              </TableBody>

                              {/* <br/><br/>
                              {order != null && order.isShoeOrder == 1 ? (<FormGroup>
                  <FormLabel>Upload Item Photo *</FormLabel>
                  <FormControl variant="outlined" fullWidth>
                      <div className="fileinput">
                      <div className={"thumbnail"}>
                          <img src={imageUrl} width="100px" />
                        </div>
                        <input
                          type="file"
                          id="imageFile"
                          onChange={handleImageChange}
                          ref={fileInput}
                        />
                      </div>
                  </FormControl>
                </FormGroup>) : '' } */}
                            </Box>
                          </TableContainer>

                    <Grid container justify="space-between">
                      <Grid item xs={isShowSaveButton() ? 6 : 12} sm={isShowSaveButton() ? 6 : 12} md={isShowSaveButton() ? 6 : 12}>
                          <Tooltip title="Add Bag" style={{ marginTop: "50px" ,width: "100%"}}>
                            <Button
                              variant="contained"
                              size="large"
                              classes={{
                                root: classes.buttonContainedWarning
                              }}
                              onClick={() => {
                                setAdditionalBagModal(true);
                              }}
                            >
                              <span>Add { order == null || subPackage == null || order.subscriptionId == null || subPackage.upToBags <= currentTotal ? 'Additional ':''}Bag</span>
                            </Button>
                          </Tooltip>
                          </Grid>
                          
                      <Grid item xs={6} sm={6} md={6}>
                          {isShowSaveButton() ? (<Tooltip title="Save" style={{ marginTop: "50px",width: "100%" }}>
                            <Button
                              variant="contained"
                              size="large"
                              classes={{
                                root: isAllTagged()
                                  ? classes.buttonContainedSuccess
                                  : classes.buttonContainedDisabled,
                              }}
                              onClick={() => {
                                if (!isAllTagged()) {
                                  showErrorNotification(
                                    "Please tag all bags to proceed"
                                  );
                                } else {
                                  tagQrsAndUpdateStatusAction();
                                }
                              }}
                            >
                              <span>Save</span>
                            </Button>
                          </Tooltip>) : ''}
                          </Grid>
                          </Grid>
                        </Card>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              )}
            </Card>
          </Grid>
        </Grid>

        <Dialog
          classes={{
            root: classes.center + " " + classes.modalRoot,
            paper: classes.modal + " " + classes.modalSmall,
          }}
          open={scanQrModal && !isLoading}
          TransitionComponent={Transition}
          keepMounted
          onClose={() => setScanQrModal(false)}
        >
          <DialogTitle disableTypography className={classes.modalHeader}>
            <h4 className={classes.modalTitle}>Scan QR</h4>
          </DialogTitle>
          <DialogContent
            className={classes.modalBody + " " + classes.modalSmallBody}
          >
            <Box
              component={Grid}
              container
              justifyContent="center"
              className="justify-content-center"
            >
              <QrReader
                delay={300}
                onError={handleQrError}
                onScan={handleQrScan}
                style={{ width: "50%" }}
              />
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setScanQrModal()}
              classes={{
                root: classes.buttonContainedPurple100,
              }}
              variant="contained"
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          classes={{
            root: classes.center + " " + classes.modalRoot,
            paper: classes.modal + " " + classes.modalSmall,
          }}
          open={additionalBagModal && !isLoading}
          TransitionComponent={Transition}
          keepMounted
          onClose={() => setAdditionalBagModal(false)}
        >
          <DialogTitle disableTypography className={classes.modalHeader}>
            <h4 className={classes.modalTitle}>Add Additional Bag</h4>
          </DialogTitle>
          <DialogContent
            className={classes.modalBody + " " + classes.modalSmallBody}
          >
            <form>
              <FormGroup>
                <FormLabel>Bag Type</FormLabel>
                <FormControl variant="outlined" fullWidth>
                  <Select
                    value={selectedAdditionalBagType}
                    onChange={(e) => setSelectedAdditionalBagType(e.target.value)}
                    IconComponent={KeyboardArrowDown}
                  >
                    {services.map(function (srv, i) {
                      if(srv.isPerItem === 0){
                        return <MenuItem value={srv.id}>{srv.nameEn}</MenuItem>;
                      }
                    })}
                  </Select>
                </FormControl>
              </FormGroup>
            </form>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setAdditionalBagModal(false)}>Cancel</Button>
            <Button
              onClick={() => addAdditionalBag()}
              classes={{
                root: classes.buttonContainedPurple100,
              }}
              variant="contained"
            >
              Add
            </Button>
          </DialogActions>
        </Dialog>
        <Snackbar
          place="tr"
          color="success"
          // icon={AddAlert}
          message={notifMessage}
          open={success}
          closeNotification={() => setSuccess(false)}
          close
        />

        <Snackbar
          place="tr"
          color="rose"
          // icon={AddAlert}
          message={notifMessage}
          open={showError}
          closeNotification={() => setShowError(false)}
          close
        />
      </Container>
    </>
  );
};

export default TagQrCodesPage;
